.formItem {
  border-radius: 10px;
  padding: 15px;
  border: 1px solid var(--static-divider-standard);
  background-color: var(--static-background-standard);
  flex: 1.5 0 0;
  margin-right: 1rem;
}

.formDescription {
  /* padding-left: 1rem; */
  flex: 1 0 0;
}

.containerOuter {
  padding: 1rem;
  background-color: var(--static-background-standard);
  border-radius: 8px;
  border: 1px solid var(--static-divider-standard);
  margin-top: 1.5rem;
}

.formDescriptionNew {
  padding-left: 0;
  flex: 1 0 0;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: var(--static-divider-standard);
  margin: 1.5rem 0;
}
